import { createSlice } from "@reduxjs/toolkit";

const DeliveryImage = createSlice({
  name: "DeliveryImage",
  initialState: {
    deliveryImage: "",
  },
  reducers: {
    deliveryImageValue: (state, action) => {
      state.deliveryImage = action.payload.deliveryImage;
    }
  },
});

export const {
  deliveryImageValue
} = DeliveryImage.actions;
export default DeliveryImage.reducer;